import { FC } from 'react';
import IcoInfo from '@/assets/svg/ico_info.svg?react';
import BottomButtonsBlock from '@/components/blocks/BottomButtonsBlock/BottomButtonsBlock.component';
import Button from '@/components/controls/Button/Button.component';
import styles from '@/components/interactive/DialogModal/DialogModal.module.scss';
import { DialogModalPropsIF } from '@/components/interactive/DialogModal/DialogModal.types';
import ModalSheet from '@/components/interactive/ModalSheet/ModalSheet.component';
import { MODAL_SHEET_SIZES } from '@/components/interactive/ModalSheet/ModalSheet.config';

const DialogModal: FC<DialogModalPropsIF> = ({
    title = 'Вы уверены?',
    buttonLabels,
    icon,
    handleDialogAccept,
    isHideCancel,
}) => (
    <ModalSheet
        size={MODAL_SHEET_SIZES.Small}
        dataTest="dialog_modal"
        isHideClose
        isBlockOutsideClick
    >
        <div className="flcol gapBlock">
            <div className={`flcol ${styles.contentWrapper}`}>
                {icon || <IcoInfo />}
                <span>{title}</span>
            </div>
            <BottomButtonsBlock position="static">
                <Button
                    clickHandler={() => handleDialogAccept(true)}
                    className={styles.accept}
                    dataTest="button_accept"
                >
                    {buttonLabels?.yes || 'Да'}
                </Button>
                {!isHideCancel && (
                    <Button
                        clickHandler={() => handleDialogAccept(false)}
                        className={styles.decline}
                        dataTest="button_decline"
                        variant="outline"
                    >
                        {buttonLabels?.no || 'Отмена'}
                    </Button>
                )}
            </BottomButtonsBlock>
        </div>
    </ModalSheet>
);

export default DialogModal;
